import { isValidDateForDateRange } from '../utils/single-date-picker-utils';
import * as i0 from "@angular/core";
/**
 * Is Valid Date For Date Range Pipe
 *
 * Checks if a date should be selectable based on the following:
 *  1. The role of a SingleDatePicker within a DateRangeComponent (whether the datepicker is the start or end of the range)
 *  2. What date(s) are already selected for the range.
 */
export class isValidDateForDateRangePipe {
    transform(dateItemOrDate, selectedStartDate, selectedEndDate, isStartOfRange, startDate, endDate) {
        return isValidDateForDateRange(dateItemOrDate, selectedStartDate, selectedEndDate, isStartOfRange, startDate, endDate);
    }
}
isValidDateForDateRangePipe.ɵfac = function isValidDateForDateRangePipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || isValidDateForDateRangePipe)(); };
isValidDateForDateRangePipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isValidDateForDateRange", type: isValidDateForDateRangePipe, pure: true, standalone: false });
